function isUserFromList(emailAddress) {
  const useList = process.env.REACT_APP_ADDACCOUNTSTOP;
  const emailsToDisable = JSON.parse(useList);
  let present = false;
  emailsToDisable &&
    emailsToDisable?.forEach((item) => {
      if (item.includes(emailAddress)) {
        present = true;
      }
    });
  return present;
}
export { isUserFromList };
